import { CSSProperties } from "react";
import { makeStyles } from "tss-react/mui";

interface IParams {
    width?: CSSProperties["width"];
}

export const useStyle = makeStyles<IParams>()((theme, { width = 350 }) => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width,
        paddingInline: theme.spacing(2),
        paddingBlock: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#EFEFEF",
        "& > p": {
            fontWeight: "bold",
        },
    },
}));
